﻿import $ from "jquery";
import tinymce from 'tinymce';
import { showMessage, initTinymce } from "./main";

$(() => {
    var currentPage = $("#currentPage").val();
    if (currentPage != "htmlcontentDetail") return;

    init();
});

function init() {
    initTinymce('Content', 300);

    initShowImageSelectModal();
    initShowFileSelectModal();
    initUploadFile();
}

function initShowImageSelectModal() {
    $("#selectImage").off('click');

    $('#selectImage').on('click', function () {
        $('#uploadFileModal').modal('show');
    });
}

function initShowFileSelectModal() {
    $("#selectFile").off('click');
    $('#selectFile').on('click', function () {

        let fileInfo = $('#FileInfo')[0] as HTMLInputElement;
        let fileInput = document.getElementById("FileInput");

        // Skryť informáciu o uloženom súbore
        if (fileInfo) {
            fileInfo.style.display = "none";
        }
        // Zobraziť vstup pre nahranie nového súboru
        if (fileInput) {
            fileInput.style.display = "block";
        }

    });
}
function initUploadFile() {
    $('#uploadFile').on('click', function () {

        let fileInput = $('#imageForDownload')[0] as HTMLInputElement;
        let file = fileInput.files[0];

        let id = $('#Id').val();
        let languageCode = $('#LanguageCode').val();

        if (file) {
            let formData = new FormData();
            formData.append("image", file);
            formData.append("id", id.toString());
            formData.append("languageCode", languageCode.toString());

            $.ajax({
                url: '/HtmlContent/UploadImage',
                type: 'POST',
                //data: JSON.stringify(formData), 
                data: formData,
                processData: false,
                contentType: false,
                success: function (response) {
                    $('#uploadFileModal').modal('hide');
                    $('#ImageFileName').val(response.fileName);
                    $('#OriginalImageFileName').val(response.originalImageFileName);
                    $('#ImageUrl').val(response.imageUrl);
                    $('#imgImageUrl').attr('src', response.imageUrl);
                },
                error: function (xhr) {
                    let msg = xhr?.responseJSON?.message || "Chyba pri nahrávaní súboru.";
                    showMessage(msg, "Chyba!"); 
                }
            });
        } else {
            showMessage("Prosím, vyberte súbor.", "Chyba!");                
        }
    });
}


